import { withStyles } from '@material-ui/core/styles';

import cs1 from 'images/QSGs-Icon.png';
import hover1 from 'images/QSGs-Text.png';
import cs2 from 'images/ProdSupport-Icon.png';
import hover2 from 'images/ProdSupport-Text.png';
import cs3 from 'images/Helpdesk-Icon.png';
import hover3 from 'images/Helpdesk-Text.png';

import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from 'components/CncUI/Typography';

const styles = ({ breakpoints, palette }) => ({
  link: {
    placeSelf: 'center',
    height: '100%',
    width: '100%',
    placeItems: 'center',
  },
  linkImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    [breakpoints.down('sm')]: {
      minWidth: '150px',
      minHeight: '150px',
    },
  },
  body: {
    textAlign: 'center',
  },
  anchorLink: {
    color: palette.cncUI.misc.link,
  },
});

const Links = ({ classes }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={4}>
      <a
        href="https://www.castandcrew.com/plustraining"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
        id="ImageLinkStartGuide"
      >
        <img
          src={cs1}
          onMouseOver={e => (e.currentTarget.src = hover1)}
          onMouseOut={e => (e.currentTarget.src = cs1)}
          className={classes.linkImage}
          alt="Quick Start Guides"
        />
      </a>
    </Grid>
    <Grid item xs={12} sm={4}>
      <a
        href="https://www.castandcrew.com/support/customer-product-support"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
        id="ImageLinkSupport"
      >
        <img
          src={cs2}
          onMouseOver={e => (e.currentTarget.src = hover2)}
          onMouseOut={e => (e.currentTarget.src = cs2)}
          className={classes.linkImage}
          alt="Product Support"
        />
      </a>
    </Grid>
    <Grid item xs={12} sm={4}>
      <a
        href="https://support.castandcrew.com/kb/mycastcrew-u-s"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
        id="ImageLinkHelpdesk"
      >
        <img
          src={cs3}
          onMouseOver={e => (e.currentTarget.src = hover3)}
          onMouseOut={e => (e.currentTarget.src = cs3)}
          className={classes.linkImage}
          alt="Employee Helpdesk"
        />
      </a>
    </Grid>
    <Grid item xs={12}>
      <Typography variant="body1" className={classes.body}>
        Visit{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.castandcrew.com"
          className={classes.anchorLink}
        >
          www.castandcrew.com
        </Link>{' '}
        to learn more about our solutions.
      </Typography>
    </Grid>
  </Grid>
);

export default withStyles(styles)(Links);
